/// <reference path="../../meevoMessenger.module.ts" />

module Meevo.Plugins.Controls {
    import IAppointmentDataInfo = Meevo.Plugins.MeevoMessenger.IAppointmentDataInfo;
    import IRecipientRouteParams = Meevo.Plugins.MeevoMessenger.IRecipientRouteParams;
    import IAppointmentServiceClientData = Meevo.Plugins.MeevoMessenger.IAppointmentServiceClientData;
    import IAppointmentData = Meevo.Plugins.MeevoMessenger.IAppointmentData;

    class ClientMenuOptionsModalController {

        static $inject = ["recipientRoutingList", "isClientMessaging", "appointmentData", "selectedConversationClientId","$mdDialog"]

        public recipientRoutingList;
        public isClientMessaging: boolean;
        public appointmentDataInfo: IAppointmentDataInfo[];
        public serviceClientData: IAppointmentDataInfo;
        public clientId: Guid;
        public clientNames;

        constructor(recipientRoutingList: any, isClientMessaging: boolean, appointmentData: IAppointmentDataInfo[],
                    selectedConversationClientId: Guid, private $mdDialog: angular.material.IDialogService) {

            this.recipientRoutingList = recipientRoutingList;
            this.isClientMessaging = isClientMessaging;
            this.appointmentDataInfo = appointmentData;
            this.clientId = selectedConversationClientId;

            this.getNeededAppointmentDataBtClientId()
        }

        getNeededAppointmentDataBtClientId() {
            this.serviceClientData = this.appointmentDataInfo.find((elem: IAppointmentDataInfo) => elem.payingClientId == this.clientId)
        }

        gotoState(recipientRouting: IRecipientRouteParams, appointmentData: IAppointmentServiceClientData) {
            recipientRouting.options.onClick({recipientRouting, appointmentData})
        }

        cancel = () => {
            this.$mdDialog.hide();
        }
    }

    angular.module("meevo.plugins.meevoMessenger")
        .controller("meevo.plugins.ClientMenuOptionsModalController", ClientMenuOptionsModalController);
}
